// src/modules/LiberaProximaVenda/services/documentService.js
import { fetchData } from '../../../utils/datasource';

/**
 * Searches for budget documents
 * @param {string} branch - The branch code
 * @param {string} documentNumber - The document number
 * @returns {Promise<Array>} Array of budget documents
 * @throws {Error} If the API request fails
 */
export const searchBudget = async (branch, documentNumber) => {
  try {
    const URL = `/sibeapp/orcamentos?filial=${branch}&numdoc=${documentNumber}`;
    console.log(URL)
    const response = await fetchData(URL, 'GET', {}, 30000);
    if (!response.ok) {
      throw new Error('Failed to search budget');
    }

    const result = await response.json();

    if (result.status !== 'ok') {
      throw new Error('Invalid response status');
    }

    return result.data || [];
  } catch (error) {
    console.error('Error searching budget:', error);
    throw error;
  }
};

/**
 * Searches for service order documents
 * @param {string} branch - The branch code
 * @param {string} documentNumber - The document number
 * @returns {Promise<Array>} Array of service order documents
 * @throws {Error} If the API request fails
 */
export const searchServiceOrder = async (branch, documentNumber) => {
  try {
    const URL = `/sibeapp/ordensservico?filial=${branch}&numdoc=${documentNumber}`;
    console.log(URL)
    const response = await fetchData(URL, 'GET', {}, 30000);
    if (!response.ok) {
      throw new Error('Failed to search service order');
    }

    const result = await response.json();

    if (result.status !== 'ok') {
      throw new Error('Invalid response status');
    }

    return result.data || [];
  } catch (error) {
    console.error('Error searching service order:', error);
    throw error;
  }
};

/**
 * Releases the next sale for a document
 * @param {string} branch - The branch code
 * @param {string} documentNumber - The document number
 * @returns {Promise<Object>} Response from the API
 * @throws {Error} If the API request fails
 */
export const releaseNextSale = async (branch, documentNumber, cliente, loja, userName, tipo) => {

  try {

    const URL = `/sibeapp/liberavenda?filial=${branch}&numdoc=${documentNumber}&cliente=${cliente}&loja=${loja}&usuario=${userName}&tipo=${tipo}`;
    console.log(URL)
    const response = await fetchData(URL, 'POST', {}, 30000);

    if (!response.ok) {
      throw new Error('Failed to release next sale');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error releasing next sale:', error);
    throw error;
  }
};
